// src/pages/user/Hotels/RoomImagesPage.jsx
import React from 'react';

const RoomImagesPage = () => {
  return (
    <div>
      <h1>Room Images</h1>
      <p>Manage images of rooms here.</p>
    </div>
  );
};

export default RoomImagesPage;
